
import * as angular from "angular";

export class ScrollToDirective implements angular.IDirective {

    public restrict = "A";

    constructor(private $timeout: angular.ITimeoutService) {
    }

    public link = (scope: angular.IScope, element: angular.IAugmentedJQuery, attributes: angular.IAttributes) => {

        attributes.$observe("scrollTo", () => {

            this.$timeout(() => {
                this.scrollTo(element, attributes["scrollTo"]);
            });
        });

        attributes.$observe("scrollOn", () => {

            this.$timeout(() => {
                this.scrollTo(element, attributes["scrollTo"]);
            });
        });
    }

    scrollTo(element: angular.IAugmentedJQuery, position: string) {

        if (position === "bottom") {
            element.scrollTop(element[0].scrollHeight);
        }
        else if (position === "top") {
            element.scrollTop(0);
        } else {
            element.scrollTop(parseInt(position));
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService) => new ScrollToDirective($timeout);

        directive.$inject = ["$timeout"];

        return directive;
    }
}
